import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NotificationBar from "@components/NotificationBarAudit/index";
import "./uploaded-details.scss";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import qs from "query-string";
import { getValue } from "@utils/lodash";
import { toast } from "react-toastify";
import moment from "moment";
import {
  adminGetAllAuditList,
  adminGetAuditDashboardInfo,
  adminUpdateAudit,
} from "@services/audit.service";
import { NavLink } from "react-router-dom";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import { concatDotToDocumentString, formatText } from "@_common/text-helpers";
import { Col, Label, Modal, ModalBody, Row } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import UploadModal from "./Modal/upload";
import CommentsModal from "./Modal/comments";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { clientDeleteSubmitCheckpointLocation } from "@services/auth.service";
import NoAccessPage from "@components/common/NoAccess";
import ReactTooltip from "react-tooltip";
import { commentsTitleList, commentsValueList } from "@_common/comments";
import "./table.scss";
import { sanitizeInput } from "@_common/dompurify";
export default function DashboardUploadedDetails(props: any) {
  const navigate = useNavigate();
  const mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [recommendation, setRecommendation] = useState("");
  const [common_nc_group, setCommon_nc_group] = useState("");
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      // getDashboardInfo();
      setDate(new Date());
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getDashboardInfo();
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [remittance_date, setRemittance_date] = useState(null);
  const [expiry_date, setExpiry_date] = useState(null);
  const [dashboardInfo, setDashboardInfo] = useState({});
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const getDashboardInfo = async () => {
    const payload: any = {
      location_id: mainParams.id,
      month: mainParams.date ? parseInt(mainParams.date.split("-")[1]) : "",
      year: mainParams.date ? parseInt(mainParams.date.split("-")[0]) : "",
      vendor_id: "",
      // domain_name: getValue(localStorage, `client`, ""),
      type: "SUMMERY",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = qs.stringify(payload);
    try {
      setDashboardLoading(true);
      const resp = await adminGetAuditDashboardInfo(payload);
      if (resp) {
        setDashboardLoading(false);
        setDashboardInfo(getValue(resp, `data`, ""));
      } else {
        setDashboardLoading(false);
      }
    } catch (error) {
      setDashboardLoading(false);
    }
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const dates = date ? date : new Date();

    const payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by,
      upload_status: mainParams.upload === "-" ? "" : mainParams.upload,
      audit_status: mainParams.audit === "-" ? "" : mainParams.audit,
      vendor_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      // domain_name: getValue(localStorage, `client`, ""),
      is_active: true,
      // audit_type:
      // 	mainParams.route === "uploaded"
      // 		? "UPLOADED"
      // 		: mainParams.route === "not-uploaded"
      // 		? "NOT_UPLOADED"
      // 		: "COMPLETED",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      const resp = await adminGetAllAuditList(queryRequest);
      if (resp) {
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataRefetch = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const dates = date ? date : new Date();

    const payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by,
      // upload_status: params.update_status,
      upload_status: mainParams.upload === "-" ? "" : mainParams.upload,
      audit_status: mainParams.audit === "-" ? "" : mainParams.audit,
      vendor_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      // domain_name: getValue(localStorage, `client`, ""),
      is_active: true,
      is_redirect: true,
      // audit_type:
      // 	mainParams.route === "uploaded"
      // 		? "UPLOADED"
      // 		: mainParams.route === "not-uploaded"
      // 		? "NOT_UPLOADED"
      // 		: "COMPLETED",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      const resp = await adminGetAllAuditList(queryRequest);
      if (resp) {
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleDeleteFile = async (documentId: string, id: string) => {
    try {
      const resp = await clientDeleteSubmitCheckpointLocation(
        documentId,
        id,
        // getValue(localStorage, `client`, "")
      );
      if (resp) {
        toast.success("Deleted successfully");
        getDataRefetch();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [comments, setComments] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmitTask = async () => {
    try {
      const date1 = JSON.parse(JSON.stringify(remittance_date));
      const date2 = JSON.parse(JSON.stringify(expiry_date));
      if (comments) {
        setSubmitLoading(true);
        const payload: any = {
          ids: selectedIndex,
          audit_status: update_status,
          commentsInfo: {
            comments: comments,
            type:
              update_status === "SEND_BACK_TO_VENDOR"
                ? "REJECT_COMMENT"
                : "ACCEPTANCE_COMMENT",
          },
          // domain_name: getValue(localStorage, `client`, ""),
          remittance_date: date1 ? moment(date1).format("YYYY-MM-DD") : "",
          expiry_date: date2 ? moment(date2).format("YYYY-MM-DD") : "",
          recommendation: recommendation,
          // common_nc_group: selectedCommentLabel
          // 	? selectedCommentLabel + ` - ` + selectedCommentValue
          // 	: "",
        };
        Object.keys(payload).forEach((key) => {
          if (!payload[key] || payload[key] === undefined) {
            delete payload[key];
          }
        });
        const resp = await adminUpdateAudit(mainParams.id, payload);
        if (resp) {
          setSubmitLoading(false);
          toast.success("Submitted successfully");
          handleModal2();
          setComments("");
          getDataRefetch();
          setSelectedIndex([]);
          setRemittance_date(null);
          setExpiry_date(null);
          setSelectedCommentLabel("");
          setSelectedCommentValue("");
        }
      } else {
        toast.error("Please add comments");
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };
  const [update_status, setupdate_status] = useState("");
  const handleUpdateStatus = async (update_status: string) => {
    setupdate_status(update_status);
    handleModal2();
  };
  const handleUpdateStatusSpecific = async (
    update_status: string,
    id: string,
  ) => {
    let uniq =
      getValue(selectedIndex, `length`, 0) > 0
        ? selectedIndex.filter((item: string) => item === id)
        : [];
    if (uniq.length === 0) {
      selectedIndex.push(id);
    }
    setupdate_status(update_status);
    handleModal2();
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.page_no = page_no;
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    const queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      const payload: any = { ...params };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      const queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const payload: any = {
      search_text: e.target.value,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [isOpen1, setIsOpen1] = useState(false);
  const handleModal1 = () => {
    setIsOpen1(!isOpen1);
  };

  const [isOpen2, setIsOpen2] = useState(false);
  const handleModal2 = () => {
    setIsOpen2(!isOpen2);
  };

  const [vendorInfo, setVendorInfo] = useState({});
  const handleModalComment = (obj: object) => {
    setVendorInfo(obj);
    handleModal();
  };
  const handleModalCommentCancel = () => {
    setVendorInfo({});
    handleModal();
  };

  const handleModalUpload = (obj: object) => {
    setVendorInfo(obj);
    handleModal1();
  };
  const handleModalUploadCancel = () => {
    setVendorInfo({});
    handleModal1();
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                                 */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    const dates = moment(date).format("YYYY-MM-DD");
    const payload: any = {
      date: dates,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    const queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Checkbox Section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIndex, setSelectedIndex] = useState<any>([]);

  const handleChangeCheckbox = (id: string) => {
    const selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    } else {
      const selected = selectedIndex.filter((item: string) => item !== id);
      setSelectedIndex(selected);
    }
  };

  const [all, setAll] = useState("false");
  const handleChangeAllLocations = (value: string) => {
    setAll(value);
    if (value === "true") {
      const loc = locations.map((item: object) => getValue(item, `id`, ""));
      setSelectedIndex(loc);
    } else {
      setSelectedIndex([]);
    }
  };

  const handleRemoveNavItems = () => {
    handleChangeAllLocations("false");
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const enableCopy: any =
    getValue(selectedIndex, `length`, 0) === 1
      ? getValue(locations, `length`, 0) > 0 &&
        locations.filter(
          (item: object) =>
            getValue(item, `id`, "") === getValue(selectedIndex, `[${0}]`, ""),
        )
      : [];

  const [filterOptions] = useState([
    { value: "COMPLIED", label: "COMPLIED" },
    { value: "PARTIALLY_COMPLIED", label: "PARTIALLY COMPLIED" },
    { value: "NON_COMPLIED", label: "NON-COMPLIED" },
    { value: "NOT_APPLICABLE", label: "NOT APPLICABLE" },
    { value: "SEND_BACK_TO_VENDOR", label: "REJECT BACK TO VENDOR" },
  ]);

  const [selectedCommentLabel, setSelectedCommentLabel] = useState<any>("");
  const [selectedCommentValue, setSelectedCommentValue] = useState<any>("");
  const handleChangeComments = (type: string, value: string) => {
    if (type === "label") {
      setSelectedCommentLabel(value);
      setComments(`${value} - ${selectedCommentValue}`);
    } else {
      setSelectedCommentValue(value);
      setComments(`${selectedCommentLabel} - ${value}`);
    }
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "audit_manage_audit",
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          {
            // mainParams.route === "uploaded" &&
            getValue(selectedIndex, `length`, 0) > 0 &&
              getValue(props, `permissions`, []).includes("update") && (
                <NotificationBar
                  isFilterVisisbile={true}
                  selectedIDs={selectedIndex}
                  handleRemoveNavItems={handleRemoveNavItems}
                  filterOptions={filterOptions}
                  handleUpdateStatus={handleUpdateStatus}
                  permissions={props.permissions}
                />
              )
          }
          <div className="dashboard-wrapper__header d-flex mb-4 align-items-center">
            <NavLink to={`/dashboard/vendor-audits?date=${mainParams.date}`}>
              <img src="/images/back-link.svg" className="img-fluid" />
            </NavLink>
            &nbsp;&nbsp;&nbsp;
            <h6>{getValue(mainParams, `name`, "")}</h6>
          </div>

          <section className="table-uploaded-details-wrapper">
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : getValue(locations, `length`, 0) > 0 ? (
              <>
                <div className="audit-table-container">
                  <table>
                    <thead>
                      <th>
                        <h5 className="header">
                          {/* Select All */}
                          {mainParams.route !== "not-uploaded" && (
                            <label
                              className="m-0 position-relative"
                              htmlFor="header-checkbox"
                            >
                              <input
                                type="checkbox"
                                className="default-checkbox"
                                id="header-checkbox"
                                onChange={() =>
                                  handleChangeAllLocations(
                                    all === "true" ? "false" : "true",
                                  )
                                }
                                checked={
                                  locations.length === selectedIndex.length &&
                                  all === "true"
                                }
                              />
                              <div className="custom-checkbox">
                                <img
                                  src="/images/uploaded-details/tick.svg"
                                  className="img-fluid uploaded-tick"
                                />
                              </div>
                            </label>
                          )}
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </h5>
                        <p className="subHeader"></p>
                      </th>
                      <th>
                        <h5 className="header">Form name</h5>
                        <p className="subHeader">Task ID</p>
                      </th>
                      <th>
                        <h5 className="header">Legislation</h5>
                        <p className="subHeader">Compliance Activity</p>
                      </th>
                      <th>
                        <h5 className="header">Location Name</h5>
                        <p className="subHeader">Audit Status</p>
                      </th>
                      <th>
                        <h5 className="header">Risk</h5>
                        {/* <p className="subHeader">Risk</p> */}
                      </th>
                      <th>
                        <h5 className="header">Action</h5>
                        {/* <p className="subHeader">Action</p> */}
                      </th>
                    </thead>
                    <tbody>
                      {getValue(locations, `length`, 0) > 0 &&
                        locations.map((bodyObj: object, index: number) => {
                          return (
                            <React.Fragment key={index}>
                              <tr>
                                <td>
                                  {mainParams.route !== "not-uploaded" && (
                                    <label
                                      className="m-0 position-relative"
                                      htmlFor={`details-${index}`}
                                    >
                                      <input
                                        type="checkbox"
                                        className="default-checkbox"
                                        id={`details-${index}`}
                                        checked={selectedIndex.includes(
                                          getValue(bodyObj, `id`, ""),
                                        )}
                                        onChange={() =>
                                          handleChangeCheckbox(
                                            getValue(bodyObj, `id`, ""),
                                          )
                                        }
                                      />
                                      <div className="custom-checkbox">
                                        <img
                                          src="/images/uploaded-details/tick.svg"
                                          className="img-fluid uploaded-tick"
                                        />
                                      </div>
                                    </label>
                                  )}
                                </td>
                                <td>
                                  <div className="body-container">
                                    <p className="title">
                                      {getValue(
                                        bodyObj,
                                        `checkpoint.form_no`,
                                        "",
                                      )}
                                    </p>
                                    {/* <p className="desc">
																			{getValue(bodyObj, `task_id`, "")}
																		</p> */}
                                    <p className="uploaded-details-wrapper__body-text mt-2">
                                      <span style={{ position: "relative" }}>
                                        {getValue(bodyObj, `task_id`, "")}
                                        <ReactTooltip id="count">
                                          <span>Submit Count</span>
                                        </ReactTooltip>
                                        {parseInt(
                                          getValue(bodyObj, `submit_count`, 1),
                                        ) > 1 && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              height: "20px",
                                              width: "20px",
                                              borderRadius: "10px",
                                              backgroundColor: "#ff2d55",
                                              right: "-21px",
                                              top: "-6px",
                                            }}
                                            data-tip
                                            data-for="count"
                                          >
                                            <p
                                              style={{
                                                color: "white",
                                                textAlign: "center",
                                                fontSize: "12px",
                                                alignContent: "center",
                                                marginTop: "2px",
                                              }}
                                            >
                                              {getValue(
                                                bodyObj,
                                                `submit_count`,
                                                "",
                                              )}
                                            </p>
                                          </div>
                                        )}
                                      </span>
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <div className="body-container">
                                    <p className="title">
                                      {getValue(
                                        bodyObj,
                                        `checkpoint.legislation.legislation_name`,
                                        "",
                                      )}
                                    </p>
                                    <p className="desc">
                                      {getValue(
                                        bodyObj,
                                        `checkpoint.compliance_activity`,
                                        "",
                                      )}
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <div className="body-container">
                                    <p
                                      className="title-green"
                                      data-tip
                                      data-for={`location${index}`}
                                    >
                                      {formatText(
                                        getValue(
                                          bodyObj,
                                          `location.location_name`,
                                          "",
                                        ),
                                      )}
                                    </p>
                                    <p className="desc">
                                      {formatText(
                                        getValue(bodyObj, `audit_status`, ""),
                                      )}
                                    </p>
                                  </div>
                                  <ReactTooltip id={`location${index}`}>
                                    <span>
                                      {getValue(
                                        bodyObj,
                                        `location.address1`,
                                        "",
                                      )}
                                      ,{" "}
                                      {getValue(
                                        bodyObj,
                                        `location.city.name`,
                                        "",
                                      )}
                                      ,{" "}
                                      {getValue(
                                        bodyObj,
                                        `location.pincode`,
                                        "",
                                      )}
                                    </span>
                                  </ReactTooltip>
                                </td>
                                <td>
                                  <div className="body-container">
                                    <p className="title">
                                      {getValue(
                                        bodyObj,
                                        `checkpoint.impact_on_organization.text`,
                                        "-",
                                      )}
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <div className="body-container">
                                    {getValue(
                                      props,
                                      `permissions`,
                                      [],
                                    ).includes("update") ? (
                                      <div className="document-icons">
                                        {/* {
																				mainParams.route === "uploaded" ?
																				 ( */}
                                        <>
                                          <div
                                            data-tip
                                            data-for="happyFace"
                                            // className="uploaded-details-wrapper__icons-wrapper_image"
                                          >
                                            <img
                                              src="/images/uploaded-details/img4.svg"
                                              className="img-fluid cursor-pointer"
                                              height={36}
                                              width={36}
                                              onClick={() =>
                                                getValue(
                                                  props,
                                                  `permissions`,
                                                  [],
                                                ).includes("update") &&
                                                handleUpdateStatusSpecific(
                                                  "NOT_APPLICABLE",
                                                  getValue(bodyObj, `id`, ""),
                                                )
                                              }
                                            />
                                          </div>
                                          <div
                                            data-tip
                                            data-for="happyFace1"
                                            // className="uploaded-details-wrapper__icons-wrapper_image"
                                          >
                                            <img
                                              src="/images/uploaded-details/img3.svg"
                                              className="img-fluid cursor-pointer"
                                              height={36}
                                              width={36}
                                              onClick={() =>
                                                getValue(
                                                  props,
                                                  `permissions`,
                                                  [],
                                                ).includes("update") &&
                                                handleUpdateStatusSpecific(
                                                  "COMPLIED",
                                                  getValue(bodyObj, `id`, ""),
                                                )
                                              }
                                            />
                                          </div>
                                          <div
                                            data-tip
                                            data-for="happyFace2"
                                            // className="uploaded-details-wrapper__icons-wrapper_image"
                                          >
                                            <img
                                              src="/images/uploaded-details/img6.svg"
                                              className="img-fluid cursor-pointer"
                                              height={36}
                                              width={36}
                                              onClick={() =>
                                                getValue(
                                                  props,
                                                  `permissions`,
                                                  [],
                                                ).includes("update") &&
                                                handleUpdateStatusSpecific(
                                                  "NON_COMPLIED",
                                                  getValue(bodyObj, `id`, ""),
                                                )
                                              }
                                            />
                                          </div>
                                        </>
                                        {/* ) : null} */}
                                        <div
                                          data-tip
                                          data-for="happyFace3"
                                          // className="uploaded-details-wrapper__icons-wrapper_image"
                                        >
                                          <img
                                            src="/images/uploaded-details/img1.svg"
                                            className="img-fluid cursor-pointer"
                                            height={36}
                                            width={36}
                                            onClick={() =>
                                              handleModalUpload(bodyObj)
                                            }
                                          />
                                        </div>
                                        <div
                                          data-tip
                                          data-for={`comments${index}`}
                                          // className="uploaded-details-wrapper__icons-wrapper_image"
                                        >
                                          <img
                                            src="/images/uploaded-details/img2.svg"
                                            className="img-fluid cursor-pointer"
                                            height={36}
                                            width={36}
                                            onClick={() =>
                                              handleModalComment(bodyObj)
                                            }
                                          />
                                        </div>
                                        <ReactTooltip id="happyFace1">
                                          <span>Complied</span>
                                        </ReactTooltip>
                                        <ReactTooltip id="happyFace">
                                          <span>Not Applicable</span>
                                        </ReactTooltip>
                                        <ReactTooltip id="happyFace2">
                                          <span>Non Complied</span>
                                        </ReactTooltip>
                                        <ReactTooltip id="happyFace3">
                                          <span>Upload</span>
                                        </ReactTooltip>
                                        <ReactTooltip id={`comments${index}`}>
                                          <span>
                                            {" "}
                                            Comment :{" "}
                                            {getValue(
                                              bodyObj,
                                              `recent_comment.comments`,
                                              "",
                                            )}
                                            ,{" "}
                                          </span>
                                        </ReactTooltip>
                                      </div>
                                    ) : null}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={6}>
                                  <div className="table-documents-container">
                                    {getValue(bodyObj, `documents`, []).map(
                                      (documentsObj: object, i: number) => {
                                        return (
                                          <div
                                            className=" table-document d-flex align-items-center"
                                            key={i}
                                          >
                                            <img
                                              src={`/images/uploaded-details/${
                                                getValue(
                                                  documentsObj,
                                                  `type`,
                                                  "",
                                                )
                                                  ? getValue(
                                                      documentsObj,
                                                      `type`,
                                                      "",
                                                    )
                                                  : getValue(
                                                        documentsObj,
                                                        `file_type`,
                                                        "",
                                                      ) === "document"
                                                    ? "pdf"
                                                    : "word"
                                              }.svg`}
                                              className="img-fluid cursor-pointer"
                                            />
                                            <p
                                              className="text"
                                              onClick={() =>
                                                handleDownloadOnClick(
                                                  getValue(
                                                    documentsObj,
                                                    `url`,
                                                    "",
                                                  ),
                                                  getValue(
                                                    documentsObj,
                                                    `name`,
                                                    "",
                                                  ),
                                                )
                                              }
                                            >
                                              {concatDotToDocumentString(
                                                getValue(
                                                  documentsObj,
                                                  `name`,
                                                  "",
                                                ),
                                              )}
                                            </p>
                                          </div>
                                        );
                                      },
                                    )}
                                  </div>
                                  <div className="table-separator"></div>
                                </td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </table>
                  {totalCount !== 0 && (
                    <div className="d-flex justify-content-between">
                      {locations.length > 0 && (
                        <img
                          src="/images/profile-illustration.svg"
                          className="img-fluid"
                        />
                      )}
                      {totalCount > 100 ? (
                        <PaginationPage
                          totalCount={totalCount}
                          limit={limit}
                          pageNumber={page_no}
                          handleChangePagination={handleChangePagination}
                          handleChangeLimit={handleChangeLimit}
                        />
                      ) : (
                        <p className="show-rows-count mt-3 d-flex">
                          Total Count:&nbsp;&nbsp;{" "}
                          <p style={{ color: "rgb(13, 110, 253)" }}>
                            {totalCount}
                          </p>
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                {Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
              </>
            )}
            {isOpen && (
              <CommentsModal
                {...props}
                isOpen={isOpen}
                handleModal={handleModalCommentCancel}
                vendorInfo={vendorInfo}
                edit={true}
                permissions={getValue(props, `permissions`, [])}
              />
            )}
            {isOpen1 && (
              <UploadModal
                {...props}
                isOpen={isOpen1}
                handleModal={handleModalUploadCancel}
                vendorInfo={vendorInfo}
                getData={getDataRefetch}
                permissions={getValue(props, `permissions`, [])}
              />
            )}
            {isOpen2 && (
              <Modal
                isOpen={isOpen2}
                toggle={() => handleModal2()}
                centered
                className="add-comments-popup"
              >
                <div className="d-flex justify-content-between add-comments-popup__header">
                  <h3>Add Comments</h3>
                  <img
                    src="/images/close-black.svg"
                    className="img-fluid cursor-pointer"
                    onClick={handleModal2}
                  />
                </div>
                <ModalBody>
                  <p className="mb-3">Predefined Comments : </p>
                  <div className="grid mb-1">
                    <div className="input-grid-item">
                      {/* <Label>Type</Label> */}
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Select Type"
                        options={commentsTitleList}
                        value={commentsTitleList.filter(
                          (item: any) =>
                            getValue(item, `value`, "") ===
                            selectedCommentLabel,
                        )}
                        onChange={(e: any) =>
                          handleChangeComments(
                            "label",
                            getValue(e, `value`, ""),
                          )
                        }
                        isClear
                      />
                    </div>
                    <div className="input-grid-item">
                      {/* <Label>Value</Label> */}
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Select Value"
                        options={getValue(
                          commentsValueList,
                          `[${selectedCommentLabel}]`,
                          [],
                        )}
                        value={getValue(
                          commentsValueList,
                          `[${selectedCommentLabel}]`,
                          [],
                        ).filter(
                          (item: any) =>
                            getValue(item, `value`, "") ===
                            selectedCommentValue,
                        )}
                        onChange={(e: any) =>
                          handleChangeComments(
                            "value",
                            getValue(e, `value`, ""),
                          )
                        }
                        isClear
                      />
                    </div>
                  </div>
                  <InputField
                    inputType="TEXTAREA"
                    value={comments}
                    onChange={(e: any) =>
                      setComments(sanitizeInput(e.target.value))
                    }
                    placeholder="Add Comment"
                    rows="10"
                    className="add-comments-popup__form-control"
                  />
                  <br />
                  {update_status === "COMPLIED" && (
                    <Row>
                      <Col md="6">
                        <Label>Remittance Date</Label>
                        <InputField
                          inputType="DATETYPE-DOB"
                          className="form-control w-100"
                          placeholderText="Enter Remittance Date"
                          value={remittance_date}
                          onChange={(e: any) => setRemittance_date(e)}
                          // minDate={new Date(mainParams.date)}
                        />
                      </Col>
                      <Col md="6">
                        <Label>Expiry Date</Label>
                        <InputField
                          inputType="DATETYPE-DOB"
                          className="form-control"
                          placeholderText="Enter Expiry Date"
                          value={expiry_date}
                          onChange={(e: any) => setExpiry_date(e)}
                          // minDate={new Date()}
                        />
                      </Col>
                    </Row>
                  )}
                  <div className="">
                    <div className="">
                      <Label>Recommendation</Label>
                      <InputField
                        inputType="TEXT"
                        value={recommendation}
                        onChange={(e: any) =>
                          setRecommendation(sanitizeInput(e.target.value))
                        }
                        placeholder="Add Recommendation"
                        className="add-comments-popup__form-control"
                        label={"Recommendation"}
                      />
                    </div>
                  </div>
                </ModalBody>
                <div className="d-flex justify-content-end add-comments-popup__footer">
                  <button
                    className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                    onClick={() => handleModal2()}
                  >
                    Close
                  </button>
                  {submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                      onClick={handleSubmitTask}
                      disabled={
                        !getValue(props, `permissions`, []).includes("update")
                      }
                    >
                      Submit
                    </button>
                  )}
                </div>
              </Modal>
            )}
          </section>
        </>
      )}
    </DashboardLayout>
  );
}
